/**
 * ローカルストレージで格納するアクセストークンのキー名
 */
export const LOCAL_STORAGE_ACCESS_TOKEN_KEY = 'access_token'
/**
 * ローカルストレージで格納するリフレッシュトークンのキー名
 */
export const LOCAL_STORAGE_REFRESH_TOKEN_KEY = 'refresh_token'
